"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseImage = parseImage;
const Util_1 = require("../../Util");
const imageAssets_1 = require("../../imageAssets");
const KICAD_IMAGE_DPI = 300;
const MM_PER_INCH = 25.4;
function parseImage(node, warnings) {
    let center = [0, 0];
    let scale = 1;
    let uuid = '';
    const dataChunks = [];
    for (const child of node.nodes) {
        switch (child.name) {
            case 'at': {
                center = [parseFloat(child.values[0]), parseFloat(child.values[1])];
                break;
            }
            case 'scale': {
                const parsed = parseFloat(child.values[0]);
                if (Number.isFinite(parsed) && parsed > 0) {
                    scale = parsed;
                }
                break;
            }
            case 'uuid': {
                uuid = (0, Util_1.removeQuotes)(child.values[0] ?? '');
                break;
            }
            case 'data': {
                dataChunks.push(...child.values.map((value) => (0, Util_1.removeQuotes)(value)));
                break;
            }
        }
    }
    const label = uuid.length > 0 ? uuid : '(no uuid)';
    if (!Number.isFinite(center[0]) || !Number.isFinite(center[1])) {
        warnings.push(`Skipped schematic image ${label}: its position could not be read`);
        return null;
    }
    const base64 = dataChunks.join('');
    if (base64.length === 0) {
        warnings.push(`Skipped schematic image ${label}: it carries no data`);
        return null;
    }
    let data;
    let mimeType;
    try {
        ({ data, mimeType } = (0, imageAssets_1.decodeBase64Image)(base64));
    }
    catch {
        warnings.push(`Skipped schematic image ${label}: its data is not valid base64`);
        return null;
    }
    if (mimeType === 'application/octet-stream') {
        warnings.push(`Skipped schematic image ${label}: its format is not recognised (PNG, JPEG and BMP are supported)`);
        return null;
    }
    const pixelSize = (0, imageAssets_1.readImagePixelSize)(data, mimeType);
    if (!pixelSize) {
        warnings.push(`Skipped schematic image ${label}: its ${mimeType} header does not hold readable dimensions`);
        return null;
    }
    const width = (pixelSize.width * MM_PER_INCH * scale) / KICAD_IMAGE_DPI;
    const height = (pixelSize.height * MM_PER_INCH * scale) / KICAD_IMAGE_DPI;
    const ref = (0, imageAssets_1.computeImageRef)(base64, mimeType);
    return {
        drawing: {
            type: 'image',
            pos: [center[0] - width / 2, center[1] - height / 2],
            width,
            height,
            imageRef: ref,
        },
        asset: {
            ref,
            name: uuid.length > 0 ? uuid : ref,
            data,
            mimeType,
        },
    };
}
//# sourceMappingURL=v6ParseImage.js.map